import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { paths } from '@/paths'

export function PostHogPageviewTracker() {
  const location = useLocation()
  const posthogClient = usePostHog()

  useEffect(() => {
    if (!posthogClient) return
    // Son adresse porte le code « en tant que » de la console, que `$current_url` emporterait.
    if (location.pathname === paths.impersonate) return
    posthogClient.capture('$pageview')
  }, [location.pathname, location.search, posthogClient])

  return null
}
